
import { useEffect, useState } from "react";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import SettingTable from "./ChequeTable";
import {useToastHandler } from '../../../common/ToastHandler'
import useSwal from '../../../common/ReusableComponent/useSwal'
import LoadingOverlay from "../../../common/LoadingBar.js";
import loader from "../../../../assets/Image/Loader2.gif";
import { useNavigate } from "react-router-dom";
import useMyPermissions from "../../../../utils/permissions/useMyPermissions";


export default function ChequeHistory() {
  const { getAPI, Delete, _Get, Get } = useApi();
  const { can } = useMyPermissions();
  const [historyCheque, setHistoryCheque] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);
const { handleToast } = useToastHandler()
const {confirmDelete} = useSwal()
const navigate = useNavigate();
  const handleGetChequeHistory = async () => {
    try {
      setLoading(true);
      const response = await _Get("chequeData");
      setHistoryCheque(response.results);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch cheque history");
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetChequeHistory();
  }, []);

  const columns = [
    { header: "Name", field: "name" },
    { header: "Amount", field: "amount" },
    { header: "cheque_no", field: "cheque_no" },
    { header: "Digital Signature", field: "digital_signature" },
    { header: "Created At", field: "created_at" },
    { header: "Created By", field: "created_by" },
  ];

  const handleEdit = (cheque) => {
    // toast.info("You cannot edit a created cheque.");
    handleToast({
      type: "INFO",
      message: "You cannot edit a created cheque."
    });
  };

  const handleDelete = async (chequeId) => {
    try {
      const result = await confirmDelete(); 
      if (result.isConfirmed) {
        const response = await Delete('chequeData', chequeId);
        if (response) {
          handleToast({
            type: "SUCCESS",
            message: "Cheque deleted successfully!"
          });
          handleGetChequeHistory();
          setHistoryCheque((prevHistory) =>
            prevHistory.filter((cheque) => cheque.cheque_no !== chequeId)
          );
        } else {
          handleToast({
            type: "ERROR",
            message: "Failed to delete cheque."
          });
        }
      }
    } catch (err) {
      handleToast({
        type: "ERROR",
        message: "Error occurred while deleting cheque."
      });
    }
  };
  
  // Print Again handler
  const handlePrintAgain = async (cheque) => {
    try {
      // Fetch full cheque data by ID using getAPI
      const chequeId = cheque.id || cheque.cheque_no;
      const chequeUrl = `${getAPI('chequeData')}${chequeId}/`;
      const chequeData = await Get(chequeUrl);

      let layoutData = null;
      // If layout info is stored as layout_id, fetch the layout using getAPI
      if (chequeData.layout_id) {
        const layoutUrl = `${getAPI('preferenceCompanyData')}${chequeData.layout_id}/`;
        layoutData = await Get(layoutUrl);
      } else if (chequeData.layout) {
        layoutData = chequeData.layout; // If layout JSON is stored directly
      }

      // Navigate to ChequePreview with cheque data and layout
      navigate("/cheque-preview", {
        state: {
          ...chequeData,
          chequeNumber: chequeData.cheque_no, // normalize for preview
          date: chequeData.created_at || chequeData.date, // use created_at as date for preview
          layout: layoutData,
          printAgain: true,
        },
      });
    } catch (error) {
      handleToast({
        type: "ERROR",
        message: "Failed to fetch cheque details for re-printing."
      });
      console.error("Print Again error:", error);
    }
  };

  if (loading) {
    return (
      <LoadingOverlay loading={loading} loader={loader} />
    );
  }

  return (
    <div className="responsive-box">
      {/* <h2 style={{ textAlign: "top"}}>Cheque History</h2> */}
      <SettingTable
        showExport={true}
        data={historyCheque}
        columns={columns}
        showFooter={true}
        showAction={true}
        shouldEdit={true}
        onEdit={handleEdit}
        onDelete={can("chequeService", "delete") ? handleDelete : undefined}
        onPrintAgain={handlePrintAgain}
        apiUrl={getAPI(`chequeData`)}
      />
    </div>
  );
}
